<template>
  <base-dialog
    :title="'house.param.roofShape.title' | i18n"
    :subtitle="'house.param.roofShape.subtitle' | i18n"
    :description="'house.param.roofShape.description' | i18n">

    <table style="width: 100%; table-layout: fixed;">
      <tr>
        <td v-for="shape in shapes.slice(0, 3)" :key="shape.value" @click="roofShape = shape" :class="{ 'selected': shape == roofShape }">
          <div class="img-wrap">
            <img :src="shape.icon" />
          </div>
          {{ shape.label }}
        </td>
      </tr>

      <tr>
        <td v-for="shape in shapes.slice(3, 6)" :key="shape.value" @click="roofShape = shape" :class="{ 'selected': shape == roofShape }">
          <div class="img-wrap">
            <img :src="shape.icon" />
          </div>
          {{ shape.label }}
        </td>
      </tr>
    </table>
  </base-dialog>
</template>


<script>
  import Vue from 'vue'
  import BaseDialog from "./BaseDialog"
  import { mapState } from 'vuex'
  import { roofShapes, defaultRoofShape } from '../../api/constants'

  export default {
    props: [
      'title',
      'subtitle',
      'description',
      'value'
    ],

    computed: {
      roofShape: {
        get() {
          return this.$store.state.houseParams.roofShape
        },
        set(roofShape) {
          this.$store.commit('houseParams/SET_ROOF_SHAPE', roofShape)
        }
      }
    },

    data() {
      return {
        shapes: roofShapes
      }
    },

    created() {
      if(this.roofShape == null) {
        this.$store.commit('houseParams/SET_ROOF_SHAPE', defaultRoofShape)
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  .img-wrap {
    vertical-align: middle;
    text-align: center;
    height: 80px;
    line-height: 80px;
  }
  .img-wrap img {
    max-width: 100%;
    max-height: 100%;
  }
  td {
    padding: 3px;
    cursor: pointer;
    text-align: center;
    font-size: small;
    border-bottom: 5px solid white;
  }
  td:hover {
    background-color: #eee;
    color: #32cd32;
    border-color: #32cd32;
  }
  .selected {
    color: green;
    border-color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/HouseRoofShapeDialog.vue